import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const SectionFormSettingsRoot = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'flex flex-col rounded-lg border border-b border-gray-400 bg-white p-6',
      className
    )}
    {...props}
  />
)
